import accounting from "accounting";

export const renderCycleRepr = (billing) => {
	let base = '';
	let modifier = '';
	let plural = '';
	let num;

	if (billing.rebillMonths) {
		base = 'month';
		num = billing.rebillMonths;
	} else if (billing.rebillWeeks) {
		base = 'week';
		num = billing.rebillWeeks;
	} else {
		base = 'cycle'; // Fallback if we can't figure out what the cycle name is
	}

	if (num > 1) {
		modifier = '' + num + ' ';
		plural = 's';
	}

	return modifier + base + plural;
};

// Returns just the currency symbol & price e.g. $100.00
export const renderPerCyclePriceShort = (price, term, currencySymbol) => {
	// render the per-cyle price, e.g. $12/month
	let priceShort = price / term['numCycles'];
	priceShort = accounting.formatMoney(priceShort / 100, currencySymbol).toString();

	let priceShortLength = priceShort.length;
	if (priceShort.substring(priceShortLength - 2, priceShortLength) == "00") {
		priceShort = priceShort.substring(0, priceShortLength - 3);
	}

	return priceShort;
};

export const renderPerCyclePrice = (price, term, billing, currencySymbol) => {
	let cyclePriceShort = renderPerCyclePriceShort(price, term, currencySymbol);

	return cyclePriceShort + ' / ' + renderCycleRepr(billing);
};
